<div class="modal-header">
  <h1 class="modal-title">Legal notices</h1>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.close()"
  ></button>
</div>
<div class="modal-body">
  <ul class="nav justify-content-end">
    <li class="nav-item">
      <a
        href="javascript:void(0)"
        class="nav-link"
        (click)="scrollTo('privacyPolicy')"
        >Privacy Policy</a
      >
    </li>
    <li class="nav-item">
      <a
        href="javascript:void(0)"
        class="nav-link"
        (click)="scrollTo('cookiesPolicy')"
        >Cookie Policy</a
      >
    </li>
  </ul>
  <div class="legalContent" [innerHTML]="content() ?? ''"></div>
</div>
